<template>
  <tr>
    <td>{{ user.name }}</td>
    <td>{{ user.email }}</td>
    <td>{{ user.phone }}</td>
    <td>
      <button class="btn btn-sm btn-primary" @click="selectIt()">
        <i class="fa fa-check-circle"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    user: {
      required: true
    }
  },
  methods: {
    selectIt: function() {
      this.$emit('teacherSelected', this.user)
    }
  }
}
</script>

<style>

</style>
